import { theme } from '.';

export const getColor = (color: keyof typeof theme.colors): string => {
  return theme.colors[color] || theme.colors.primary;
};
